import React from 'react';

import './style.scss';

const OrgIcon = () => {
  return (
    <svg className="uni-avatar__icon" viewBox="0 0 32 32" version="1.1">
      <path
        d="M4.93562921,21.4824043 L4.06307827,20.6098534 C3.97897391,20.525749 3.97897391,
        20.3893889 4.06307827,20.3052846 L4.56561346,19.8027494 C4.64971781,19.718645 4.78607792,
        19.718645 4.87018227,19.8027494 L5.38501732,20.3175844 L5.38501732,11.0646603 L4.87018227,
        11.5794954 C4.78607792,11.6635998 4.64971781,11.6635998 4.56561346,11.5794954 L4.06307827,
        11.0769602 C3.97897391,10.9928559 3.97897391,10.8564957 4.06307827,10.7723914 L4.93562921,
        9.89984045 L4.06307827,9.0272895 C3.97897391,8.94318515 3.97897391,8.80682504 4.06307827,
        8.72272069 L4.56561346,8.2201855 C4.64971781,8.13608114 4.78607792,8.13608114 4.87018227,
        8.2201855 L5.38501732,8.73502055 L5.38501732,7.8614507 C5.38501732,7.38568461 5.77070194,
        7 6.24646802,7 C6.34246785,7 6.43779249,7.01604652 6.52850158,7.04747627 L29.4203482,
        14.9792598 C29.8698939,15.1350226 30.1080519,15.6257221 29.9522891,16.0752678 C29.8658547,
        16.3247251 29.6698056,16.5207743 29.4203482,16.6072086 L6.52850158,24.5389922 C6.07895591,
        24.694755 5.58825642,24.4565969 5.43249359,24.0070513 C5.40106384,23.9163422 5.38501732,
        23.8210176 5.38501732,23.7250177 L5.38501732,22.6472242 L4.87018227,23.1620593 C4.78607792,
        23.2461636 4.64971781,23.2461636 4.56561346,23.1620593 L4.06307827,22.6595241 C3.97897391,
        22.5754197 3.97897391,22.4390596 4.06307827,22.3549553 L4.93562921,21.4824043 Z M7.43000001,
        9.10000038 C7.19251756,9.10000038 7,9.32673884 7,9.6064349 L7,21.973566 C7,22.253262 7.19251756,
        22.4800005 7.43000001,22.4800005 C7.66748245,22.4800005 7.86000001,22.253262 7.86000001,
        21.973566 L7.86000001,9.6064349 C7.86000001,9.32673884 7.66748245,9.10000038 7.43000001,
        9.10000038 Z"
        fillOpacity="0.4"
        fill="#E6F2FF"
      />
    </svg>
  );
};

export default OrgIcon;



// WEBPACK FOOTER //
// ./src/avatars/__partials/org-icon.jsx